

import barba from '@barba/core';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'


export default class{

	constructor(){
        gsap.registerPlugin(ScrollTrigger)
      
        barba.hooks.afterOnce((data) => {
            this.run()
        });
        
        barba.hooks.after((data) => {
            this.run()
        });

    }

    
    run(){
        const vh = (coef) => (window.innerHeight * (coef/100)) - 20;
        const jobs = document.querySelector("#p-jobs")
        if(jobs){
            ScrollTrigger.matchMedia({
            "(min-width: 1200px)": function() {

                gsap.fromTo('.bg01 > img',
                    { 
                        x: "0", 
                    }, 
                    { //アニメーションしたい要素を指定
                    x: "-45%", 
                    scrollTrigger: {
                        trigger: '.js-sticky__wrapper--job01',//アニメーションが始まるトリガーとなる要素
                        start: 'top 20px', 
                        end: 'bottom bottom-=' + vh(30), 
                        pin: '.bg01',
                        scrub: true, 
                    }
                });
                gsap.fromTo('.bg02 > img',
                    { 
                        x: "0", 
                    }, 
                    { //アニメーションしたい要素を指定
                    x: "-45%", 
                    scrollTrigger: {
                        trigger: '.js-sticky__wrapper--job02',//アニメーションが始まるトリガーとなる要素
                        start: 'top 20px', 
                        end: 'bottom bottom-=' + vh(30), 
                        pin: '.bg02',
                        scrub: true, 
                        //markers: true,
                    }
                });
            },
            "(min-width: 992px) and (max-width: 1199px) ": function() {

                gsap.fromTo('.bg01 > img',
                    { 
                        x: "0", 
                    }, 
                    { //アニメーションしたい要素を指定
                    x: "-45%", 
                    scrollTrigger: {
                        trigger: '.js-sticky__wrapper--job01',//アニメーションが始まるトリガーとなる要素
                        start: 'top 20px', 
                        end: 'bottom bottom-=' + vh(30), 
                        pin: '.bg01',
                        scrub: true, 
                    }
                });
                gsap.fromTo('.bg02 > img',
                    { 
                        x: "0", 
                    }, 
                    { //アニメーションしたい要素を指定
                    x: "-45%", 
                    scrollTrigger: {
                        trigger: '.js-sticky__wrapper--job02',//アニメーションが始まるトリガーとなる要素
                        start: 'top 20px', 
                        end: 'bottom bottom-=' + vh(30), 
                        pin: '.bg02',
                        scrub: true, 
                        //markers: true,
                    }
                });
            }
            });
        }
    }
        
}